"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_ENVIRONMENT_FIELDS = void 0;
exports.getEnvVarMappings = getEnvVarMappings;
/**
 * Single source of truth for client environment configuration.
 *
 * This config drives:
 * - Jinja2 template generation for env.js
 * - Mapping between env vars and runtime keys
 *
 * Adding a new field requires:
 * 1. Add entry here
 * 2. Add to ClientRuntimeEnvSchema in clientEnvironmentSchema.ts
 * 3. Add to ClientConfigSecretsSchema in clientEnvironmentSchema.ts
 * 4. Rebuild the env.js.j2 template: npm run generate:env-template
 */
exports.CLIENT_ENVIRONMENT_FIELDS = [
    {
        runtimeKey: 'sentryDsn',
        envVar: 'SENTRY_DSN',
        description: 'Sentry DSN for error reporting',
    },
    {
        runtimeKey: 'highlightProjectId',
        envVar: 'HIGHLIGHT_PROJECT_ID',
        description: 'Highlight.io project ID for session replay',
    },
];
/**
 * Get the mapping of runtime keys to environment variable names.
 * Used for template generation.
 */
function getEnvVarMappings() {
    return exports.CLIENT_ENVIRONMENT_FIELDS.map((field) => ({
        runtimeKey: field.runtimeKey,
        envVar: field.envVar,
    }));
}
//# sourceMappingURL=clientEnvironmentConfig.js.map